import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import $ from "jquery"; // Still used for preloader
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Import useNavigate
// Assuming these are local utility functions for toasts
import { errorMessage } from "../utils/tostify";

// Assuming these Redux actions/selectors are correctly imported from userSlice
import { getallmembershiptypes } from "../store/slices/userSlice";
// No direct axios call here, payment logic moved to RenewPaymentPage

// React-Bootstrap Imports
import { Container, Row, Col, Form, Card, Button } from 'react-bootstrap';
// Make sure you have React-Bootstrap installed: npm install react-bootstrap bootstrap
// And include Bootstrap CSS in your entry file (e.g., index.js or App.js):
// import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from "../components/Navbar"; // Assuming this path is correct
import Sidebar from "../components/Sidebar"; // Assuming this path is correct

function RenewMembership() {
  const { error, status } = useSelector((state) => state.user); // Redux state
  const dispatch = useDispatch(); // Redux dispatch
  const navigate = useNavigate(); // Initialize useNavigate
  const [membershipTypes, setMembershipTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      $(".preloader").fadeOut(); // Hide preloader on component mount
    } catch (error) {
      console.error("Error hiding preloader:", error);
    }
  }, []);
  
  useEffect(() => {
    try {
      if (status === "failed" && error) {
        errorMessage(error);
      }
    } catch (e) {
      console.error("Error handling global error message:", e);
    }
  }, [error, status]);
  

  // Fetch membership types on component mount
  useEffect(() => {
    const fetchMembershipTypes = async () => {
      setLoading(true);
      try {
        const response = await getallmembershiptypes(); 
        //const response = unwrapResult(actionResult); // Use unwrapResult
        if (response?.status === 200 && response.data) {
          setMembershipTypes(
            Array.isArray(response.data)
              ? response.data.filter((type) => type.status === "1")
              : []
          );
        } else {
          errorMessage("Error fetching membership types!");
        }
      } catch (error) {
        console.error("Error fetching membership types:", error);
        errorMessage("Error fetching membership types!");
      } finally {
        setLoading(false);
      }
    };
    fetchMembershipTypes();
  }, [dispatch]); // Dependency on dispatch for thunk

  const formik = useFormik({
    initialValues: {
      member: localStorage.getItem('id'),
      membershiptype: "",
      validUpto: "",
      amount: 0,
    },
    validationSchema: Yup.object({
      membershiptype: Yup.string().required("Membership type is required"),
    }),
    onSubmit: async (values) => {
      try {
        console.log("Renew Membership Form Submitted", values);
  
        const selectedMembership = membershipTypes.find(
          (type) => type.id === values.membershiptype
        );
  
        if (!selectedMembership || selectedMembership.amount <= 0) {
          errorMessage("Selected membership type has no valid amount.");
          return;
        }
  
        navigate('/renew-payment', {
          state: {
            membershipTypeId: selectedMembership.id,
            membershipTypeName: selectedMembership.name,
            membershipTypeAmount: selectedMembership.amount,
            newValidUpto: values.validUpto,
            paypalPlanId: selectedMembership.paypal_plan_id
          }
        });
      } catch (error) {
        console.error("Error during membership renewal submission:", error);
        errorMessage("Something went wrong while processing your request.");
      }
    },
  });
  
  // Helper function to unwrap Redux Toolkit async thunk results
  function unwrapResult(result) {
    if (result.payload) {
      return result.payload;
    } else if (result.error) {
      throw result.error;
    }
    return result;
  }

  // Handle membership type selection change
  const handleMembershipTypeChange = (e) => {
    try {
      const selectedMembershipId = e.target.value;
      const selectedType = membershipTypes.find(
        (type) => type.id === selectedMembershipId
      );
  
      formik.handleChange(e); // Let Formik handle the 'membershiptype' field
  
      if (selectedType) {
        // Calculate validUpto: Extend from the current 'validupto' in localStorage.
        const currentValidUpto = localStorage.getItem('validupto');
        let newDate = new Date(); // Default to today
  
        if (currentValidUpto) {
          const parts = currentValidUpto.split('-');
          if (parts.length === 3) {
            newDate = new Date(parts[0], parts[1] - 1, parts[2]);
          } else {
            console.warn("Invalid 'validupto' format in localStorage.");
          }
        } else {
          console.warn("'validupto' not found in localStorage.");
        }
  
        // Add duration to date
        const duration = parseInt(selectedType.duration);
        if (!isNaN(duration)) {
          newDate.setDate(newDate.getDate() + duration);
          formik.setFieldValue("validUpto", newDate.toISOString().split("T")[0]);
        } else {
          console.warn("Invalid duration in selected membership type.");
          formik.setFieldValue("validUpto", "");
        }
  
        formik.setFieldValue("amount", parseFloat(selectedType.amount) || 0);
      } else {
        formik.setFieldValue("validUpto", "");
        formik.setFieldValue("amount", 0);
      }
    } catch (error) {
      console.error("Error in handleMembershipTypeChange:", error);
      formik.setFieldValue("validUpto", "");
      formik.setFieldValue("amount", 0);
    }
  };
  
  return (
    <div>
      <Navbar />
      <Sidebar />
      {loading && (
        <div className="preloader" style={{ display: "block" }}>
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <Container fluid> {/* Use React-Bootstrap Container */}
              <div className="folio-container"></div> {/* Keep this if it's a specific layout div */}
              <Row className="justify-content-center"> {/* Centered content */}
                <Col lg={6} md={8}> {/* Adjusted column size to center the form */}
                  <Card className="w-100"> {/* Use React-Bootstrap Card */}
                    <Card.Header style={{ background: "#f06969" }}>
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <h4 className="card-title fw-semibold text-white">Renew Membership</h4> {/* Added text-white for visibility */}
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <Form onSubmit={formik.handleSubmit}> {/* Use React-Bootstrap Form */}
                        <Row>
                          {/* Membership Type Dropdown */}
                          <Col md={12}>
                            <Form.Group className="mb-3" controlId="membershiptype">
                              <Form.Label>Select New Membership Type</Form.Label>
                              <Form.Select
                                {...formik.getFieldProps("membershiptype")}
                                onChange={handleMembershipTypeChange}
                                isInvalid={formik.touched.membershiptype && !!formik.errors.membershiptype}
                              >
                                <option value="">Select Membership Type</option>
                                {membershipTypes.map((type) => (
                                  <option key={type.id} value={type.id}>
                                    {type.name} - {type.duration} days - ${type.amount}
                                  </option>
                                ))}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.membershiptype}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          {/* Valid Upto (Display only, calculated) */}
                          {formik.values.validUpto && (
                            <Col md={12}>
                              <Form.Group className="mb-3" controlId="validUpto">
                                <Form.Label>New Membership Valid Until</Form.Label>
                                <Form.Control
                                  type="date"
                                  value={formik.values.validUpto}
                                  readOnly
                                />
                              </Form.Group>
                            </Col>
                          )}
                        </Row>

                        {/* Submit Button */}
                        <div className="text-center mt-3">
                          <Button variant="dark" type="submit" className="w-50" >
                            Proceed to Payment
                          </Button>
                        </div>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RenewMembership;